import type {
  Answer,
  UIThreadMessagesItem,
} from "../../generated/core-api";

/** Extract the structured assistant answer from a thread message, if present. */
export function extractAssistantAnswer(
  messages: UIThreadMessagesItem[],
  messageIndex: number,
): Answer | null {
  const message = messages[messageIndex];
  if (!message || message.role !== "assistant") {
    return null;
  }

  const response = message.content.response;
  if (!("elements" in response)) {
    return null;
  }

  return response as Answer;
}
